import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import LocationSearchTabs from "./LocationSearchTabs.js";
const LocationSearchTabsContainer = (props) => {
  const { getLabel } = useIntl();
  const [tabIndex, setTabIndex] = React.useState(0);
  const ref = React.createRef();
  const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
  const labels = React.useMemo(
    () => ({
      listTab: getLabel("locations.search.tabs.list"),
      mapTab: getLabel("locations.search.tabs.map")
    }),
    [getLabel]
  );
  React.useEffect(() => {
    let timeout;
    if (tabIndex === 1) {
      timeout = setTimeout(() => {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        ref?.current?.scrollIntoView({
          block: "end",
          behavior: prefersReducedMotion ? "auto" : "smooth"
        });
      }, 100);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [tabIndex]);
  return /* @__PURE__ */ React.createElement(
    LocationSearchTabs,
    {
      ...props,
      tabsRef: ref,
      labels,
      showTabs: props.showTabs ?? false,
      tabIndex,
      onChange: setTabIndex,
      isMobile
    }
  );
};
export {
  LocationSearchTabsContainer as default
};
//# sourceMappingURL=LocationSearchTabsContainer.js.map
